import { render, staticRenderFns } from "./DictionarySelect.vue?vue&type=template&id=25ad1b8d&"
import script from "./DictionarySelect.vue?vue&type=script&lang=js&"
export * from "./DictionarySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports